import { Link } from 'react-router-dom';

export function NotFoundPage(): React.JSX.Element {
  return (
    <>
      <header className="page__header">
        <h1 className="page__title">Page not found</h1>
      </header>
      <section className="panel">
        <div className="panel__body">
          <p style={{ marginTop: 0 }}>That page does not exist.</p>
          <Link className="btn" to="/dashboard">
            Back to dashboard
          </Link>
        </div>
      </section>
    </>
  );
}
